import MenuItem from '@mui/material/MenuItem';
import React, {useState, useEffect} from 'react' 
import PropTypes from 'prop-types'; 
import {useTranslation} from "react-i18next"
import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton'; 
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Paper from '@mui/material/Paper';
import PanToolAltIcon from '@mui/icons-material/PanToolAlt'; 
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography'; 
import TableFooter from '@mui/material/TableFooter';
import useTheme from '@mui/material/styles/useTheme';
import visuallyHidden from '@mui/utils/visuallyHidden';
import "css/customDialog.css";

const headCellsStore = [
  {
    id: 'tradename',
    numeric: false,
    disablePadding: false,
    label: 'Text_tradename',
    canOrder:true
  },
  {
    id: 'documentid',
    numeric: false,
    disablePadding: false,
    label: 'Text_documentid',
    canOrder:true
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Text_name',
    canOrder:true
  },
  {
    id: 'contacperson',
    numeric: false,
    disablePadding: false, 
    label: 'Text_FORM_CONTACT',
    canOrder:true
  },
  {
    id: 'enabled',
    numeric: false,
    disablePadding: false,
    label: 'Text_enabled',
    canOrder:false
  }
];

EnhancedTableHead.propTypes = {
  onRequestSort: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
};

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}
  
function getComparator(order, orderBy) {
    return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}
  
function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
        return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

function EnhancedTableHead(props) {
  const { order, orderBy, onRequestSort, t } = props;
  const createSortHandler = (property) => (event) => { onRequestSort(event, property); };
  return (
    <TableHead>
      <TableRow>
        <TableCell
          key='edit'
          align='center'
          padding='normal'
          sortDirection={false}
        >
          <Typography style={{color:"#4e73df", fontSize: 16}} >
            {t('Button_Select')}
          </Typography>
        </TableCell>
        {headCellsStore.map((headCell, indexhead) => (
          <TableCell
            key={indexhead}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            {headCell.canOrder ?(
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
                {orderBy === headCell.id ? (
                  <Box component="span" sx={visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </Box>
                ) : null}
              </Typography>
            </TableSortLabel>):
              <Typography style={{color:"#4e73df", fontSize: 16}} >  
                {t(headCell.label)}
              </Typography>}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

const EnhancedTableToolbar = (props) => {
  const { textHead, textReg, numTotRegFilter,numTotRegStore, textOf  } = props;
    return (
      <Toolbar>
        <Typography style={{flex: '1 1 100%',color:"#4e73df", fontSize: 28}} id="tableTitle" component="div">
          {textHead}
        </Typography>
        <Typography style={{flexShrink: 0, ml: 2.5, color:"#4e73df", fontSize: 18}} id="tableTitle" component="div">
          {textReg} {(numTotRegFilter).toLocaleString('de-DE')} {textOf} {(numTotRegStore).toLocaleString('de-DE')}
        </Typography>
    </Toolbar>
    );
};

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;
  const {t} = useTranslation(['listDataGeneralSettings']);

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label={t('Text_First_Page')}
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label={t('Text_Previous_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Next_Page')}
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label={t('Text_Last_Page')}
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TableSortingFormStore =(props)=>{
  const { 
    dataStore,
    numTotRegFilter,
    titleTable, 
    numTotRegStore,
    activeOffsetStore,
    rangeOffsetStore,
    currencyOffsetStore,
    setCurrencyOffsetStore,
    selectStores,
    setFormForm,
    handleCloseDataEditStore
  } = props;
  const {t} = useTranslation(['listDataForms']);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [emptyRows, setEmptyRows] = useState(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataStore.length) : 0);
  const [countData,setCountData] = useState(dataStore.length);
  
  useEffect(
    () => {
      if (dataStore.length!==countData || dataStore.length<=rowsPerPage){
        setPage(0);
      }  
      setCountData(dataStore.length);
      setEmptyRows(page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataStore.length) : 0);  
    },
    [dataStore,page,setEmptyRows,rowsPerPage,countData]
  );

  const handleChangeOffset = (event) => {
    setCurrencyOffsetStore(event.target.value);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  
  const selectDefaultStore = (row) => {
    switch (selectStores) {
      case "Opt_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          opt_tras_documentid:row.documentid
        }));
        break;
      case "Ori_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          ori_tras_documentid:row.documentid
        }));
        break;
      case "Aut_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          aut_tras_documentid:row.documentid
        }));
        break;
      case "Dest_Tras": 
        setFormForm(formForm => ({
          ...formForm,
          dest_tras_documentid:row.documentid
        }));
        break;
      case "Aut_Dest": 
        setFormForm(formForm => ({
          ...formForm,
          aut_dest_documentid:row.documentid
        }));
        break;
      case "Rel_Trans": 
        setFormForm(formForm => ({
          ...formForm,
          rel_trans_documentid:row.documentid
        }));
        break;
      case "Resp_Prod": 
        setFormForm(formForm => ({
          ...formForm,
          resp_prod_documentid:row.documentid
        }));
        break;
      default:
        break;
    } 
    handleCloseDataEditStore();
  };
  const listItems= (
  stableSort(dataStore, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, keyData) => {
    return (
      <TableRow hover tabIndex={-1} key={keyData}>
        {(row.id!=="" && row.id!==null ) &&
          <TableCell align="center">
            <IconButton  size="large"  className="edit-select-button" onClick={row.enabled?()=>selectDefaultStore(row):() => {}}>
              <PanToolAltIcon style={{fontSize: 28}}/>
            </IconButton>
          </TableCell>
        }
        <TableCell align="left">
          <Typography style={{color:row.colorhex?row.colorhex:"#4e73df", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >
            {row.tradename}
          </Typography>  
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:row.colorhex?row.colorhex:"#4e73df", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >  
            {row.documentid}
          </Typography>
        </TableCell>
        <TableCell align="left">
          <Typography style={{color:row.colorhex?row.colorhex:"#4e73df", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >
            {row.name}
          </Typography>
        </TableCell>
      <TableCell align="left">
            <Typography style={{color:row.colorhex?row.colorhex:"#4e73df", fontSize: 16, textDecorationLine: row.enabled?'':'line-through'}} >  
              {row.contacperson}
            </Typography>
        </TableCell>
        <TableCell align="center">
          <Checkbox checked={row.enabled} 
            sx={{
              '& .MuiSvgIcon-root': { fontSize: 28 }, // Ajusta el tamaño del ícono
            }}
            disabled
          />
        </TableCell>  
      </TableRow>
    );
  }));
  
  return(
    <>
      <Box sx={{ width: '100%' }}> 
        <EnhancedTableToolbar textHead={t(titleTable)} textReg={t('Text_Num_Reg')} numTotRegFilter={numTotRegFilter} numTotRegStore={numTotRegStore} textOf={t('Text_Of')}/>
          <TableContainer component={Paper} className="formdi-table-container" >
            <Table sx={{ minWidth: '750px' }} stickyHeader size="small"  aria-labelledby="tableTitle"> 
              <EnhancedTableHead order={order} orderBy={orderBy} onRequestSort={handleRequestSort} t={t} />
              <TableBody>    
                {listItems}
                {emptyRows > 0 && (
                <TableRow style={{ height: 33  * emptyRows}}>
                  <TableCell colSpan={14} />
                </TableRow>
                )}
              </TableBody>
              <TableFooter>
                <TableRow>
                {activeOffsetStore && (
                    <TableCell colSpan={2}>
                      <Box sx={{ flexShrink: 0, p: 1}}>
                        <div className="form-group">
                          <TextField autoComplete="off"
                            id="currencyOffsetStore"
                            name="currencyOffsetStore"
                            value={currencyOffsetStore}
                            inputProps={{ style: {maxLength: 100, color:"#4e73df",fontSize:14}}}
                            placeholder={t('Text_Range_Offset')}
                            variant="standard"
                            onChange={handleChangeOffset}
                            helperText={t('Text_Range_Offset')}
                            select
                            SelectProps={{
                              native: true,
                              value: currencyOffsetStore
                            }}>
                            {rangeOffsetStore.map((option) => (
                              <MenuItem key={option.value} value={option.value}>
                                {option.label}
                              </MenuItem>
                          ))}
                          </TextField>
                        </div>
                      </Box>  
                    </TableCell>
                  )}
                  <TablePagination
                    rowsPerPageOptions={[5, 10, 25]}
                    colSpan={14}
                    count={countData}
                    rowsPerPage={rowsPerPage}
                    page={countData===0?0:page}
                    labelRowsPerPage={t('Text_Rows_Per_Page')}
                    slotProps={{
                      inputProps: {
                        'aria-label': t('Text_Rows_Per_Page'),
                      },
                      native: true,
                    }}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    ActionsComponent={TablePaginationActions}
                  />
                </TableRow>
              </TableFooter>
            </Table>
          </TableContainer>
      </Box>
    </>
  )
}

TableSortingFormStore.propTypes = {
  dataStore: PropTypes.array.isRequired,
  numTotRegFilter: PropTypes.number.isRequired,
  titleTable : PropTypes.string.isRequired,
  numTotRegStore: PropTypes.number.isRequired,
  activeOffsetStore: PropTypes.bool.isRequired,
  rangeOffsetStore: PropTypes.array.isRequired,
  currencyOffsetStore: PropTypes.number.isRequired,
  setCurrencyOffsetStore: PropTypes.func.isRequired,
  setFormForm: PropTypes.func.isRequired,
  handleCloseDataEditStore: PropTypes.func.isRequired
};
  
export default TableSortingFormStore;
